import { overviewFacts } from "@/mocks/home";

export default function Overview() {
  return (
    <section id="overview" className="bg-background-50 border-t border-background-200">
      <div className="w-full max-w-6xl mx-auto px-4 md:px-6 py-14 md:py-20">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12">
          <div className="lg:col-span-4">
            <span className="text-xs md:text-sm font-medium tracking-wide text-accent-700">
              影片概览
            </span>
            <h2 className="mt-3 font-heading text-2xl md:text-3xl font-semibold text-foreground-950 leading-snug">
              先弄清楚这部影片在讲什么
            </h2>
            <p className="mt-4 text-sm md:text-base leading-relaxed text-foreground-700">
              在一部影片的检索信息里，“完整版”“未删减”“高清”这些词出现的频率很高，但它们各自描述的是不同的事情。
              先把主题、版本与内容方向理清楚，再去查找具体信息，会节省很多来回比较的时间。
            </p>
            <div className="mt-6 rounded-lg bg-secondary-50 border border-secondary-200 p-4">
              <div className="flex items-start gap-3">
                <span className="w-8 h-8 shrink-0 rounded-md bg-secondary-500 text-background-50 flex items-center justify-center">
                  <i className="ri-bookmark-line"></i>
                </span>
                <p className="text-xs md:text-sm leading-relaxed text-secondary-900">
                  本站是信息整理类页面，不提供影片文件下载，也不引导绕过授权的观看方式，相关内容以名词解释与观看提示为主。
                </p>
              </div>
            </div>
          </div>

          <div className="lg:col-span-8 grid grid-cols-1 sm:grid-cols-2 gap-4 md:gap-5">
            {overviewFacts.map((fact) => (
              <article
                key={fact.id}
                className="rounded-lg bg-background-100 border border-background-200 p-5 md:p-6 transition-colors hover:border-accent-300"
              >
                <span className="w-11 h-11 rounded-lg bg-primary-100 text-primary-700 flex items-center justify-center">
                  <i className={`${fact.icon} text-xl`}></i>
                </span>
                <h3 className="mt-4 font-heading text-base md:text-lg font-semibold text-foreground-950">
                  {fact.title}
                </h3>
                <p className="mt-2 text-sm leading-relaxed text-foreground-600">{fact.desc}</p>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}